import { alpha, styled } from "@mui/system";
import { Autocomplete, Box, Dialog } from "@mui/material";

export const SearchDialogContainer = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    borderRadius: "8px",
    width: "90%",
    maxWidth: "500px",
    margin: "0 auto",
    overflow: "visible",
    backgroundColor: theme.palette.mode === "dark" ? "#222" : "#fff",
    boxShadow:
      theme.palette.mode === "dark"
        ? "0 8px 16px rgba(0, 0, 0, 0.5)"
        : "0 8px 16px rgba(0, 0, 0, 0.1)",
    position: "relative",
    top: "-20px",
  },
}));

export const SearchDialogHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "12px 16px",
  borderBottom: `1px solid ${
    theme.palette.mode === "dark" ? "#444" : "#e0e0e0"
  }`,
  backgroundColor: theme.palette.mode === "dark" ? "#333" : "#f5f5f5",
  borderTopLeftRadius: "8px",
  borderTopRightRadius: "8px",
}));

export const DesktopInputStyles = {
  width: 250,
  color: "white",
  "& .MuiSvgIcon-root": {
    color: "white",
  },
  borderBottomColor: "white",
  "&:before": {
    borderBottomColor: "white",
  },
  "&:after": {
    borderBottomColor: "white",
  },
  "&:hover:not(.Mui-disabled):before": {
    borderBottomColor: "white",
  },
};

export const ButtonStyle = {
  background: "none",
  color: "inherit",
  border: "none",
  padding: 0,
  font: "inherit",
  cursor: "pointer",
  outline: "inherit",
  height: "24px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const SearchContainer = styled("div")(({ theme }) => ({
  position: "relative",
  display: "flex",
  alignItems: "center",
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  borderRadius: theme.shape.borderRadius,
  marginLeft: theme.spacing(1),
  padding: theme.spacing(0.5, 1),
  transition: "width 0.3s ease",
}));

export const AnimatedAutocomplete = styled(Autocomplete)(({ theme }) => ({
  opacity: 0,
  transition: theme.transitions.create(["width", "opacity"], {
    duration: 300,
  }),
  "&.visible": {
    opacity: 1,
    marginLeft: theme.spacing(1),
  },
  "& .MuiAutocomplete-groupLabel": {
    backgroundColor: theme.palette.mode === "dark" ? "#333" : "#f5f5f5",
    color: theme.palette.mode === "dark" ? "#fff" : "#757575",
    fontWeight: 600,
    fontSize: "0.8rem",
    padding: "4px 10px",
  },
  "& .MuiAutocomplete-groupUl": {
    padding: 0,
  },
  "& .MuiAutocomplete-listbox": {
    maxHeight: "60vh",
    padding: 0,
    "& .MuiAutocomplete-option": {
      borderBottom: `1px solid ${
        theme.palette.mode === "dark"
          ? "rgba(255, 255, 255, 0.05)"
          : "rgba(0, 0, 0, 0.05)"
      }`,
      "&:last-child": {
        borderBottom: "none",
      },
      "&[aria-selected='true']": {
        backgroundColor:
          theme.palette.mode === "dark"
            ? "rgba(255, 255, 255, 0.15)"
            : "rgba(0, 0, 0, 0.05)",
      },
      "&.Mui-focused": {
        backgroundColor:
          theme.palette.mode === "dark"
            ? "rgba(255, 255, 255, 0.2)"
            : "rgba(0, 0, 0, 0.08)",
      },
    },
  },
}));
